define(function(require,exports,module){
    var nav = require('./unit/nav/navV2');
    var placeholder = require('./unit/placeholder/placeholder');
    var search = require('./unit/search/search');
    var setUserInfo = require('./unit/setUserInfo/setUserInfo');

    setUserInfo();
    search.addSearchEvent();
    nav.control.init();
    nav.handleNav();
    placeholder.init();
});


// WEBPACK FOOTER //
// ./src/js/header.js